import * as React$1 from "react";

//#region src/components/icon/static/admin-meds.svg
var _path;
function _extends() {
	return _extends = Object.assign ? Object.assign.bind() : function(n) {
		for (var e = 1; e < arguments.length; e++) {
			var t = arguments[e];
			for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
		}
		return n;
	}, _extends.apply(null, arguments);
}
var SvgAdminMeds = function SvgAdminMeds$1(props) {
	return /* @__PURE__ */ React$1.createElement("svg", _extends({
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24
	}, props), _path || (_path = /* @__PURE__ */ React$1.createElement("path", { d: "M12.715 16.715q-1.035 1.036-2.508 1.036-1.475 0-2.51-1.035a3.4 3.4 0 0 1-1.036-2.496q0-1.462 1.036-2.497L11.71 7.69q1.035-1.036 2.511-1.036t2.512 1.035a3.4 3.4 0 0 1 1.036 2.496q0 1.462-1.036 2.498zm-3.462-1.58q.51.51 1.074.388.564-.12.807-.363l1.244-1.269-1.863-1.862-1.262 1.25a1.27 1.27 0 0 0-.395.927q0 .533.395.929m5.919-5.863q-.51-.51-1.074-.392t-.808.367l-1.25 1.274 1.863 1.863 1.269-1.256q.39-.394.392-.928a1.26 1.26 0 0 0-.392-.928M5.275 21.407a2.2 2.2 0 0 1-1.607-.669A2.2 2.2 0 0 1 3 19.131V5.275q0-.938.668-1.607A2.2 2.2 0 0 1 5.275 3h4.003a3.15 3.15 0 0 1 1.159-1.456A3.05 3.05 0 0 1 12.203 1q.974 0 1.767.544T15.129 3h4.002a2.2 2.2 0 0 1 1.607.668q.669.669.669 1.607v13.856a2.2 2.2 0 0 1-.669 1.607 2.2 2.2 0 0 1-1.607.669zm0-2.276h13.856V5.275H5.275zm6.928-14.63a.775.775 0 0 0 .798-.798.775.775 0 0 0-.798-.798.775.775 0 0 0-.797.798.775.775 0 0 0 .797.798" })));
};
var admin_meds_default = SvgAdminMeds;

//#endregion
export { admin_meds_default as default };